import {Controller} from "stimulus"

export default class extends Controller {


    openModal(event) {
        const accountId = event.currentTarget.getAttribute("data-account-id")
        const scenarioActionId = event.currentTarget.closest('tbody').dataset.scenarioActionId || 
                                 window.location.pathname.match(/scenario_actions\/(\d+)/)[1]
        const frame = document.querySelector('turbo-frame[id="distributions-modal"]')
        
        const url = `/budget/scenario_actions/${scenarioActionId}/entries?gl_account_id=${accountId}`

        // For Turbo 7+, use Turbo.visit, but fallback to fetch and manual replace if needed:
        if (window.Turbo && Turbo.visit) {
            Turbo.visit(url, {frame: "distributions-modal"})
        } else if (frame) {
            fetch(url, {
                headers: {Accept: "text/vnd.turbo-stream.html"}
            })
                .then(response => response.text())
                .then(html => {
                    frame.innerHTML = html
                })
        }
    }
}